import React from "react";

/**
 * @param {string} val - The value to be formatted
 * @returns {string} formattedValue - The formatted value
 * @description it takes val and returns the formatted ABN in form of 000 000 000 000
 */
export function formatABN(val: string): string {
  const inputValue = val.replace(/\D/g, ""); // Remove all non-numeric characters

  let formattedValue = inputValue.slice(0, 2); // Extract first two digits
  const restOfValue = inputValue.slice(2); // Extract rest of the digits

  if (restOfValue.length > 0) {
    formattedValue += " " + restOfValue.match(/.{1,3}/g)?.join(" "); // Format the rest in groups of 3
  }
  if (formattedValue.length > 14) {
    formattedValue = formattedValue.slice(0, 14); // Limit to 11 digits
  }

  return formattedValue;
}

/**
 * @description it takes the event and the setter function and sets the value of the input field to the state
 * @param {React.ChangeEvent<HTMLInputElement>} e - The event object
 * @param {Function} setAbnNumber - The setter function
 * @returns {void}
 */
export function handleAbnChange(
  e: React.ChangeEvent<HTMLInputElement>,
  setAbnNumber: (value: string) => void,
): void {
  setAbnNumber(formatABN(e.target.value));
}

export const formatNumber = (
  e: React.KeyboardEvent<HTMLInputElement>,
): false | void => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

export const formatCardNumber = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  const groups = [];
  for (let i = 0; i < digits.length && i < 16; i += 4) {
    groups.push(digits.slice(i, i + 4));
  }

  return groups.join(" ");
};

export const InputTimeValidator = (
  e: React.ChangeEvent<HTMLInputElement>,
  hour: number,
): number => {
  const { value } = e.currentTarget;

  if (value.toLowerCase().includes("e")) {
    e.preventDefault();

    return hour || 0;
  }

  // Convert to number, handling potential parsing issues
  const numValue = Number(value);

  // return original value if it is not a number or greater than 24
  if (isNaN(numValue) || numValue > 24) {
    //   e.preventDefault();
    return hour || 0;
  }

  // this is for 0.5 modulo limit
  // const wholeNumber = Math.floor(numValue);
  // const decimalValue = Number(value) - wholeNumber;

  // const isModulo5 = decimalValue % 0.5 === 0;

  // if (!isModulo5) {
  //   return hour || 0;
  // }

  return Number(numValue.toFixed(2));
};

/**
 * @description it takes the event and the setter function and sets the value of the input field to the state
 * @param {React.ChangeEvent<HTMLInputElement>} e - The event object
 * @param {Function} setCardNumber - The setter function
 * @returns {void}
 */
export function handleCardNumberChange(
  e: React.ChangeEvent<HTMLInputElement>,
  setCardNumber: (value: string) => void,
): void {
  setCardNumber(formatCardNumber(e.target.value));
}

export const formatCardExpiryDate = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  let month = digits.slice(0, 2);
  let day = digits.slice(2, 4);

  if (month.length === 1 && parseInt(month) > 1) {
    month = "0" + month;
  }

  if (month.length === 2) {
    if (parseInt(month) > 12) {
      month = "12";
    }

    //Check if the month  greater than 32
    if (parseInt(day) > 32) {
      day = "32";
    }

    return `${month}${day.length > 0 ? "/" + day : ""}`;
  }

  return month;
};

/**
 * @description it takes the event and the setter function and sets the value of the input field to the state
 * @param {React.ChangeEvent<HTMLInputElement>} e - The event object
 * @param {Function} setCardExpiryDate - The setter function
 * @returns {void}
 */
export function handleCardExpiryDateChange(
  e: React.ChangeEvent<HTMLInputElement>,
  setCardExpiryDate: (value: string) => void,
): void {
  setCardExpiryDate(formatCardExpiryDate(e.target.value));
}

/**
 *
 * @description it takes the event and the setter function and sets the value of the input field to the state
 * @param {React.ChangeEvent<HTMLInputElement>} e - The event object
 * @returns {void}
 */
export function handleOnlyNumericInput(
  e: React.KeyboardEvent<HTMLInputElement>,
): void {
  if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
    e.preventDefault();
  }
}
